import PropTypes from 'prop-types';

import { Progress } from '@/components/ui/progress';

const ProgressBar = ({ value, pageName, className, ...props }) => {
	return <Progress value={value} pageName={pageName} className={className} {...props} />;
};

export default ProgressBar;

ProgressBar.propTypes = {
	value: PropTypes.number.isRequired,
	pageName: PropTypes.string,
	className: PropTypes.string,
};

ProgressBar.defaultProps = {
	value: 0,
	pageName: null,
	className: null,
};
